import { JSX, useEffect, useState } from "react";
import { wafflesKeyColumnName } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { ContractEntityOrganizationModel } from "../providerAffiliation";


interface OrganizationAccordionProps {
  organizations: ContractEntityOrganizationModel[];
}

interface OrganizationTableData {
  [wafflesKeyColumnName]: string;
  organizationNPI2: string;
  organizationName: string;
  facilityName: string;
  facilityCCN: string;
}

const OrganizationAccordion = (props: OrganizationAccordionProps): JSX.Element => {
  const [organizationData, setOrganizationData] = useState<OrganizationTableData[]>([]);
  useEffect(() => {
    const organizationData: OrganizationTableData[] = props.organizations.map((org, index) => {
      /* oxlint-disable sort-keys */
      return {
        key: index.toString(),
        organizationNPI2: org.organizationNPI2,
        organizationName: org.organizationName,
        facilityName: org.facilityName,
        facilityCCN: org.facilityCCN,
      }
    })
    setOrganizationData(organizationData);
  }, [props.organizations]);

  const columnConfig = ({
    organizationNPI2: {
      displayText: "Identifier (NPI)",
      sizeContentToFit: true,
      testId: 'affiliation-organization-npi',
    },
    organizationName: {
      displayText: "Name",
      sizeContentToFit: true,
      testId: 'affiliation-organization-name',
    },
    facilityName: {
      displayText: "Facility Name",
      sizeContentToFit: true,
      testId: 'affiliation-organization-facility-name',
    },
    facilityCCN: {
      displayText: "Facility CCN",
      sizeContentToFit: true,
      testId: 'affiliation-organization-facility-ccn'
    }
  });
  /* oxlint-enable sort-keys */

  return (
    <>
      <Waffles<OrganizationTableData>
        columns={columnConfig}
        data={organizationData}
        testId="provider-affiliation-organization-waffles"
        fullWidth={true}
      />
    </>
  )
}

export default OrganizationAccordion;
